import { MdStar } from 'react-icons/md';
import { Heading, Icon, IconContainer } from '@nbirl/nbi-common-ui-libs';

import { EmptyResources } from '../../common/components';

export const EmptyFavourites = () => (
  <EmptyResources>
    <IconContainer variant="light">
      <Icon icon={<MdStar className="text-primary-500" />} />
    </IconContainer>

    <Heading className="text-center text-gray-700">
      No favourited files or folders
    </Heading>

    <p className="text-center">
      Favourite files or folders that you want to easily find later.
    </p>
  </EmptyResources>
);
